<!--
 * @Author: your name
 * @Date: 2021-05-28 16:26:55
 * @LastEditTime: 2021-05-28 17:42:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kg_workspaced:\work\frontend\ccs-www-ng\src\components\fork.vue
-->
<template>
  <div class="fork">
    <el-form
      ref="form"
      class="search-form"
      label-width="80px"
    >
      <el-tabs
        v-model="tab"
        stretch
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          label="当前"
          name="current"
        >
          <el-form-item label="教材">
            <el-input
              v-model="textbookName"
              disabled
            />
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane
          label="其它"
          name="other"
        >
          <textbook-category-select @change="selectTextbookCategory" />

          <el-form-item label="教材">
            <el-cascader
              clearable
              filterable
              style="width: 80%;"
              :props="selectTextbookChildren"
              :options="tabOther.textbookTree"
              @change="selectTextbooks"
            >
              <template slot-scope="{ node, data }">
                <span style="float: left">{{ data.name }}</span>
                <span
                  v-if="data.isUsed === 0"
                  style="float: right; color: #8492a6; font-size: 13p"
                >（{{ $t("禁用") }}）</span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>

      <el-form-item>
        <el-button
          type="primary"
          size="small"
          @click="save()"
        >
          确定
        </el-button>
        <el-button
          size="small"
          @click="$emit('close')"
        >
          取消
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const debug = require('debug')('ccs:component:fork');
import textbookCategorySelect from './textbook_category_select';
import axios from 'axios';

export default {
	components: {
		textbookCategorySelect
	},
	props: {
		type: String, // 业务类型，upgrade：升级测试，unit：单元测试
		id: [Number, String], // 教材id，通过教材id进行复制
		version: [Number, String],
		standard: [Number, String]
	},
	data() {
		return {
			selectTextbookChildren: {
				lazy: true,
				value: 'id',
				label: 'name',
				expandTrigger: 'hover',
				lazyLoad(node, resolve) {
					// 区分业务类型
					if (this.type === 'upgrade') {
						return resolve();
					}

					if (node.value) {
						const textbookId = node.value;
						axios
							.get(`/api/textbooks/${textbookId}/child`, {
								params: {
									fields: 'id,name,nameEnUs,nameZhCn,isUsed'
								}
							})
							.then(textbooks => {
								textbooks.forEach(textbook => (textbook.leaf = true));
								resolve(textbooks);
							})
							.catch(() => resolve());
					} else {
						resolve();
					}
				}
			},

			//   选择的tab页码
			tab: 'current',

			tabCurrent: {
				textbook: null,
				id: null
			},

			tabOther: {
				textbookTree: [],
				id: null
			},
			textbookPaper: null
		};
	},
	computed: {
		// 计算属性的 getter
		textbookName: function() {
			if (this.tabCurrent.textbook) {
				return this.tabCurrent.textbook.name;
			} else {
				return '';
			}
		},

		selectTextbookId: function() {
			if (this.tab === 'current') {
				return this.tabCurrent.id;
			} else if (this.tab === 'other') {
				return this.tabOther.id;
			} else {
				return null;
			}
		}
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			debug('[init] textbookId: %s, version: %s', this.id, this.version);
			const [textbook, textbookPaper] = await Promise.all([
				axios.get(`/api/textbooks/${this.id}`, {
					params: {
						fields: 'id,name,isUsed'
					}
				}),
				axios.get(`/api/${this.type}/${this.id}`, {
					params: { version: this.version, standard: this.standard }
				})
			]);

			this.tabCurrent.textbook = textbook;
			this.tabCurrent.id = this.id;
			this.textbookPaper = textbookPaper;
		},

		async selectTextbookCategory(textbookTree) {
			this.tabOther.id = null;

			this.tabOther.textbookTree = textbookTree;
		},

		selectTextbooks(textbookTreePath) {
			debug('[selectTextbooks] textbookTreePath', textbookTreePath.join(','));
			const length = textbookTreePath.length;
			this.tabOther.id = textbookTreePath[length - 1]; // 获取选择的最后一级
		},

		async save() {
			debug('[save] from: %s, to: %s', this.unitId, this.selectUnitId);
			if (!this.selectTextbookId) {
				this.$message({
					showClose: true,
					message: '请选择要复制到的教材。',
					type: 'error'
				});
				return;
			}

			await axios.post(`/api/${this.type}/${this.selectTextbookId}`, {
				action: 'save',
				name: this.textbookPaper.name,
				describe: `forked from ${this.textbookPaper.name} ${this.id} v${
					this.version
				}`,
				devices: this.textbookPaper.devices,
				questions: this.textbookPaper.questions.map(({ question }) => {
					return {
						uuid: question.uuid,
						type: question.type
					};
				})
			});
			this.$emit('close', this.selectTextbookId);
		}
	}
};
</script>
